import { Modal } from "react-bootstrap";

const ShareByEmailPopup = ({openShareAccount, ValidateEmails, errorShareAccount, shareAccount, emails, isSharingEmail, handleEmail, modalData}) => {
  return (
    <Modal
      size="md"
      dialogClassName="modal-dialog-centered"
      show={shareAccount}
      onHide={openShareAccount}
    >
      <Modal.Body>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          onClick={openShareAccount}
        >
        </button>
        <div className="p-4">
          <div className="pt-4 text-center">
            <div className="mb-3">
              <h2 className="font-weight-boldest font-size-h2 mb-3">
                {modalData?.title ?? "Share Connection URL By Email"}
              </h2>
              <p className="font-size-lg">
              {modalData?.subTitle ?? "Send the connection URL to the account's owner. Enter the email id to share the link directly with them"}
              </p>
            </div>
            <div className="from-group">
              <textarea
                onChange={handleEmail}
                placeholder={`Ex: ${ modalData?.placeholder ?? `support@socialwalls.com,info@taggbox.com`}`}
                label="Emails"
                value={emails}
                className="form-control form-control-lg"
                id="transactionsemails"
              ></textarea>
              <span
                id="transactionsemailserror"
                className="errorMessage required"
              >
                {errorShareAccount}
              </span>
              <button
                type="submit"
                className={isSharingEmail ? "btn btn-primary btn-lg w-100 mt-5 spinner spinner-white spinner-right ": "btn btn-primary btn-lg w-100 mt-4"}
                onClick={isSharingEmail ? null : ValidateEmails}
                disabled={isSharingEmail}
              >
                {modalData?.btnText ?? "Share URL"}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareByEmailPopup;